<div class="position-relative">
  <mat-form-field [floatLabel]="floatLabel()" [class.required]="required()">
    <mat-label>{{ label() | translate }}</mat-label>
    <input matInput [matDatepicker]="picker" [autocomplete]="autocomplete()" [formControl]="date()" (dateChange)="onChangeDate($event)" (blur)="onBlur()" />
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  @if (formatError) {
    <span class="inputErrorMessage errMessage ct-date-picker">{{ formatError }}</span>
  } @else {
    <span class="inputErrorMessage errMessage ct-date-picker">{{ errorMessage() }}</span>
  }
</div>
